var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"scanner",attrs:{"id":"barcode-scanner-input","maxlength":"1"},on:{"blur":function($event){_vm.scannerBlurHandler()},"keydown":function($event){_vm.$emit('keydown', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }